import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';

/* third party javascript */
import 'bootstrap';

/* common stylesheets */
import './styles/overrides_bootstrap/bootstrap.scss';
import './styles/font.css';
import './styles/overrides_bootstrap.css';
import './styles/overrides_html.css';
import './styles/index.css';

import App from './App';
import * as serviceWorker from './serviceWorker';

import { HelmetProvider } from 'react-helmet-async';

const rootElement = document.getElementById('root');

function removeRootResourceHints(rootNode) {
    if (!rootNode) {
        return;
    }

    let currentNode = rootNode.firstChild;

    while (currentNode) {
        if (
            currentNode.nodeType === Node.ELEMENT_NODE &&
            currentNode.tagName === 'LINK'
        ) {
            const rel = currentNode.getAttribute('rel');
            if (rel === 'preload' || rel === 'modulepreload' || rel === 'prefetch') {
                const nextNode = currentNode.nextSibling;
                rootNode.removeChild(currentNode);
                currentNode = nextNode;
                continue;
            }
        }

        break;
    }
}

const app = (
    <HelmetProvider>
        <App />
    </HelmetProvider>
);

removeRootResourceHints(rootElement);

const hasSsrMarkup = rootElement.innerHTML.trim().length > 0;

if (hasSsrMarkup) {
    hydrateRoot(rootElement, app);
} else {
    createRoot(rootElement).render(app);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
